import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { format, parseISO } from "date-fns";
import { forwardRef, useEffect, useState } from "react";
import { useTranslate } from "react-admin";
import { handleAxiosError } from "../../../../common/data/axiosErrorHandler";
import {
  GeometrisWidgetVehicleEventDto,
  SafetyDashboardApiFactory,
} from "../../../../common/data/service-proxies";
import { useAxiosInstance } from "../../../../common/hooks/useAxiosInstance";
import { useTableHeaderStyles } from "../../../assets/maintenance-dashboard/common";
import { Empty } from "../../../assets/maintenance-dashboard/widgets/Empty";
import { Widget } from "../../../assets/maintenance-dashboard/widgets/Widget";
import { DriverWidgetProps } from "../common";

export const DriverGeometrisAlerts = forwardRef(
  ({ className, icon, title, driver, ...rest }: DriverWidgetProps, ref) => {
    const translate = useTranslate();
    const [loading, setLoading] = useState<boolean>(true);
    const [data, setData] = useState<GeometrisWidgetVehicleEventDto[]>();
    const axios = useAxiosInstance();
    const classes = useTableHeaderStyles();

    useEffect(() => {
      if (!axios) {
        setLoading(false);
        return;
      }

      if (!driver?.id) {
        setLoading(false);
        return;
      }

      setLoading(true);
      SafetyDashboardApiFactory(undefined, axios.defaults.baseURL, axios)
        .apiAppSafetydashboardIdGeometriseventsfordriverGet(driver.id)
        .then((result) => {
          setData(result.data);
        })
        .catch((e) => console.error(handleAxiosError(e)))
        .finally(() => setLoading(false));
    }, [axios, driver]);

    return (
      <Widget
        title={title}
        icon={icon}
        className={className}
        ref={ref}
        {...rest}
      >
        <div className="categories">
          {loading ? (
            <div className="category">
              <CircularProgress size="3rem" />
            </div>
          ) : data && data.length ? (
            <div className="table-wrapper">
              <TableContainer>
                <Table size="small">
                  <TableHead>
                    <TableRow className={classes.tableHead}>
                      <TableCell>Alert</TableCell>
                      <TableCell>Location</TableCell>
                      <TableCell>Time</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data?.map((x) => (
                      <TableRow key={x.id}>
                        <TableCell>
                          {translate(
                            `resources.admin-notifications.notificationTypes.Vehicle.${x.messageReason}`
                          )}
                        </TableCell>
                        <TableCell>{x.location}</TableCell>
                        <TableCell>
                          {format(
                            parseISO(x.timestamp!),
                            "MMM do, yyyy hh:mm:ss a"
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          ) : (
            <Empty />
          )}
        </div>
      </Widget>
    );
  }
);
